import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'insights-hub',
});

/**
 * A Backstage RouteRef for the TechInsights page of an entity.
 * @public
 */
export const techInsightsRouteRef = createRouteRef({
  id: 'tech-insights.route',
});

export const devClinicRouteRef = createSubRouteRef({
  id: 'insights-hub:devclinic',
  parent: rootRouteRef,
  path: '/devclinic',
});

export const eolDashboardRouteRef = createSubRouteRef({
  id: 'insights-hub:endoflife-dashboard',
  parent: rootRouteRef,
  path: '/eol-dashboard',
});

export const devClinicExamRoomRouteRef = createSubRouteRef({
  id: 'insights-hub:devclinic:exam-room',
  parent: rootRouteRef,
  path: '/devclinic/room/:slug',
});
